import { getNames } from 'country-list';
import { useRef, useState } from 'react';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'; // Alternative default style
import "./ContactComponent.css";

const ContactComponent = () => {
    const countries = getNames();

    const formRef = useRef();

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        city: "",
        state: "",
        country: "",
        purpose: "",
        message: ""
    });
    const [formStatus, setFormStatus] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);

    const sendContactEmail = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-contact-form`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    city: formData.city,
                    state: formData.state,
                    country: formData.country,
                    purpose: formData.purpose,
                    message: formData.message
                })
            });

            const result = await response.json();
            if (result.success) {
                setFormSuccess(true);
                setFormStatus(true);
                setTimeout(() => setFormStatus(false), 5000);
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    city: "",
                    state: "",
                    country: "",
                    purpose: "",
                    message: ""
                });
            } else {
                setFormSuccess(false);
                setFormStatus(true);
                setTimeout(() => setFormStatus(false), 5000);
            }
        } catch (err) {
            console.error(err);
            setFormSuccess(false);
            setFormStatus(true);
            setTimeout(() => setFormStatus(false), 5000);
        }
    };



    const [selectedCountry, setSelectedCountry] = useState('');

    const purposes = [
        "Sales",
        "Other"
    ];

    const [phone, setPhone] = useState("");


    return (
        <>
            <div className='dealer-top-bar'>
                <h2>We are available across India. To know about our nearest dealer, Call <a href="tel:+919512770707">+91 9512770707</a></h2>
            </div>
            <div className='contact-page-container'>
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Customer Support</h1>
                </div>
                <div className="contact-pg-content">
                    <div className="contact-row">
                        {/* Column 1: UK & Europe */}
                        <div className="contact-column">
                            <h3>Factory Unit</h3>
                            <p>
                                Marvel Decor Limited<br />
                                Plot No. 210-211<br />
                                G. I. D. C Phase-II, Dared, <br />
                                Jamnagar – 361 004,<br />
                                Gujarat<br />
                                INDIA
                            </p>
                        </div>

                        {/* Column 2: GCC */}
                        <div className="contact-column">
                            <h3>Corporate Office</h3>
                            <p>
                                Marvel Decor Limited<br />
                                1601 Remi Commercio,<br />
                                16th floor A Wing,<br />
                                Off New Link Rd, Behind<br />
                                Yash Raj Studios back gate,<br />
                                Industrial Area, Andheri West,<br />
                                Mumbai, Maharashtra - 400053
                            </p>
                        </div>

                        {/* Column 3: India */}
                        <div className="contact-column">
                            <h3>Contact Detail</h3>
                            <p style={{ display: 'flex' }}>Mobile :&nbsp; <a href="tel:+919512770707">+91 9512770707</a></p>
                            <p style={{ display: 'flex' }}>Email :&nbsp; <a href="mailto:sales@marvellifestyle.com">sales@marvellifestyle.com</a></p>
                            <a href="mailto:info@marvellifestyle.com">info@marvellifestyle.com</a>
                        </div>
                    </div>

                    {/* Contact Form Section */}
                    <div className="contact-form-section">
                        <h3>Connect To Our Consultant</h3>
                        <form className="contact-form" ref={formRef} onSubmit={sendContactEmail}>
                            <input type="hidden" name="form_type" value="Contact" />

                            {/* Name */}
                            <div className="form-group full-width">
                                <label htmlFor="name">Name*</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="Your Name"
                                    required
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                />
                            </div>

                            {/* Email + Phone */}
                            <div className="form-row">
                                <div className="form-group half-width">
                                    <label htmlFor="email">Email*</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Your Email"
                                        required
                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    />
                                </div>
                                <div className="form-group half-width">
                                    <label htmlFor="phone">Mobile*</label>
                                    <PhoneInput
                                        country={"in"}
                                        enableSearch={true}
                                        value={formData.phone}
                                        onChange={(phone) => setFormData({ ...formData, phone })}
                                        placeholder="Your Number"
                                        className="Pnum"
                                        inputProps={{
                                            name: "phone",
                                            required: true
                                        }}
                                    />
                                </div>
                            </div>

                            {/* City + State */}
                            <div className="form-row">
                                <div className="form-group half-width">
                                    <label htmlFor="city">City*</label>
                                    <input
                                        type="text"
                                        id="city"
                                        name="city"
                                        placeholder="Your City"
                                        required
                                        value={formData.city}
                                        onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                                    />
                                </div>
                                <div className="form-group half-width">
                                    <label htmlFor="state">State</label>
                                    <input
                                        type="text"
                                        id="state"
                                        name="state"
                                        placeholder="Your State"
                                        required
                                        value={formData.state}
                                        onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                                    />
                                </div>
                            </div>

                            {/* Country + Purpose */}
                            <div className="form-row">
                                <div className="form-group half-width">
                                    <label htmlFor="country">Country*</label>
                                    <select
                                        id="country"
                                        name="country"
                                        required
                                        value={formData.country}
                                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                                    >
                                        <option value="">Your Country</option>
                                        {countries.map((country, idx) => (
                                            <option value={country} key={idx}>{country}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group half-width">
                                    <label htmlFor="purpose">Purpose*</label>
                                    <select
                                        id="purpose"
                                        name="purpose"
                                        required
                                        value={formData.purpose}
                                        onChange={(e) => setFormData({ ...formData, purpose: e.target.value })}
                                    >
                                        <option value="">Select Purpose</option>
                                        {purposes.map((purpose, index) => (
                                            <option key={index} value={purpose}>{purpose}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Message */}
                            <div className="form-group full-width message-field">
                                <label htmlFor="message">Message*</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    placeholder="Your Message"
                                    required
                                    cols={40}
                                    rows={5}
                                    value={formData.message}
                                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                ></textarea>
                            </div>
                            <div className="form-notify">
                                {formStatus && formSuccess && (
                                    <p className="notify-text success">Your form has been submitted successfully!</p>
                                )}
                                {formStatus && !formSuccess && (
                                    <p className="notify-text error">There was an error submitting your form. Please try again.</p>
                                )}
                            </div>

                            <button type="submit" className="submit-btn">Submit</button>
                        </form>

                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactComponent;